import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import {
  TABS,
  SESSION_FORM_ID
} from "EventLight/Sessions/AddSessionModal/constants";
import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { getCurrentTab } from "EventLight/Sessions/AddSessionModal/selectors";
import { Div } from "components/Base";

import { getters } from "../model";

import BasicDetails from "./BasicDetails";
import BasicSubsessionDetails from "./BasicSubsessionDetails";
import Content from "EventLight/Sessions/SessionContent/View";
import Subsessions from "./Subsessions";
import Other from "EventLight/Sessions/AddSessionModal/View/Other";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(SESSION_FORM_ID)),
  connect(state => ({
    activeTab: getCurrentTab(state),
    sessionId: getters.sessionId(state),
    isSubsession: getters.isSubsession(state)
  }))
);

const Body = ({
  activeTab = TABS.BASIC_DETAILS,
  sessionId,
  isSubsession,
  handlers = {}
}) => {
  const Tab = R.prop(activeTab)({
    [TABS.BASIC_DETAILS]: isSubsession ? BasicSubsessionDetails : BasicDetails,
    [TABS.CONTENT]: Content,
    [TABS.SUBSESSIONS]: Subsessions,
    [TABS.OTHER]: Other
  });

  return (
    <Div
      bg="neutral0"
      style={{
        overflowY: "auto",
        padding: 16,
        paddingBottom: 0,
        height: "75vh"
      }}
    >
      <Tab sessionId={sessionId} handlers={handlers} />
    </Div>
  );
};

export default decorate(Body);
